import { GIFTSET, LUXGIFTSETGOLD, MINI_GIFTSET } from 'src/data/product-data'

const giftsProducts = {
  [GIFTSET.id]: {
    ...GIFTSET,
    description: `
      <p>Everything a man needs for a smooth, comfortable shave in a single box.</p>
      <ul>
        <li>A personalised chrome razor handle</li>
        <li>6 German-engineered razor blades</li>
        <li>Red blade protector</li>
        <li>Sensitive Shave Gel (150ml)</li>
        <li>Sensitive Pre-Shave Scrub (100ml)</li>
        <li>Sensitive Cooling Post-Shave Balm (75ml)</li>
        <li>£10 Gift Voucher (for new subscribers only)</li>
        <li>Gift wrap & messaging available</li>
        <li>UK express delivery available</li>
      </ul>
    `,
    images: [
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/5EteB12vCT7mybO2bZzuIE/4a2342e0aae012aeea8b25166786c22c/Lux-Box-2-optimised.jpg',
        name: GIFTSET.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/3IOE96p2Q3TiVEyG57Gno9/d384d4670a2650a07a9c29bdcc3d5216/Lux-Box-4-optimised.jpg',
        name: GIFTSET.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/1u1ALL47SCNcSsxAgBSS73/ff63041eece532479a325133fb8e3084/Handle_gift_set.jpg',
        name: GIFTSET.name
      }
    ]
  },
  [LUXGIFTSETGOLD.id]: {
    ...LUXGIFTSETGOLD,
    description: `
      <p>Everything a man needs for a smooth, comfortable shave in a single box. This box includes a limited edition Golden Razor Handle.</p>
      <ul>
        <li>£83 worth of products!</li>
        <li>A personalised Golden razor handle</li>
        <li>6 German-engineered razor blades</li>
        <li>Red blade protector</li>
        <li>Sensitive Shave Gel (150ml)</li>
        <li>Sensitive Pre-Shave Scrub (100ml)</li>
        <li>Sensitive Cooling Post-Shave Balm (75ml)</li>
        <li>£10 Gift Voucher (for new subscribers only)</li>
        <li>Gift wrap & messaging available</li>
        <li>UK express delivery available</li>
      </ul>
    `,
    images: [
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/3fzsTYPhl7gdyGgXQcCsDc/dddae2770279a65425831e5e03edf585/Lux-Box-Xmas_1_GOLD.jpg',
        name: LUXGIFTSETGOLD.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/4ZVAUGFJqlxzB8rNuAFqah/9f53ea08aea2d9040b20840b4591147d/Lux-Box-Xmas_2_GOLD.jpg',
        name: LUXGIFTSETGOLD.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/3IOE96p2Q3TiVEyG57Gno9/d384d4670a2650a07a9c29bdcc3d5216/Lux-Box-4-optimised.jpg',
        name: LUXGIFTSETGOLD.name
      }
    ]
  },
  [MINI_GIFTSET.id]: {
    ...MINI_GIFTSET,
    description: `
      <p>
        Everything a man needs for a smooth, comfortable shave, just in a mini gift box!
      </p>
      <ul>
        <li>A personalised chrome razor handle</li>
        <li>1 German-engineered razor blade</li>
        <li>Red blade protector</li>
        <li>Shave Cream (150ml)</li>
        <li>£10 Gift Voucher (for new subscribers only)</li>
        <li>Gift wrap & messaging available</li>
        <li>UK express delivery available</li>
      </ul>
    `,
    images: [
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/5LPxXS6bQrUTcrKeDBtoPJ/dade194292c41ace62e8a4f9aa29674a/Mini-pres-1-optimised.jpg',
        name: MINI_GIFTSET.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/55bAOUXqJ0DWcoNBnheoqg/81320b5294ce4e3e18dff878b4031cd5/Mini-pres-2-optimised.jpg',
        name: MINI_GIFTSET.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/3oo7lamKqlro5a3T71x1rC/09f95bfa0197bca9e74f49369ef335d6/Mini-pres-4-optimised.jpg',
        name: MINI_GIFTSET.name
      },
      {
        image:
          '//images.ctfassets.net/itvcls9imtx8/1u1ALL47SCNcSsxAgBSS73/ff63041eece532479a325133fb8e3084/Handle_gift_set.jpg',
        name: GIFTSET.name
      }
    ]
  }
}

export default giftsProducts
